class AnnouncementBanner extends HTMLElement {
    constructor() {
        super();
        this.announcementId = this.getAttribute("announcement-id");
        this.isVisible = false;
    }

    connectedCallback() {
        this.init();
    }

    init() {
        if (this.shouldShowAnnouncement()) {
            console.log("show", this.announcementId);
            setTimeout(() => {
                this.show();
            }, 1000);
        }

        this.addEventListener("click", (event) => {
            if (event.target.closest("button.announcement-banner__close")) {
                this.onClose();
            }
        });
    }

    shouldShowAnnouncement() {
        const closedAnnouncementId = localStorage.getItem(
            "closedAnnouncementId",
        );

        return closedAnnouncementId !== this.announcementId;
    }

    show() {
        this.classList.add("announcement-banner--visible");
        this.isVisible = true;
        this.inert = false;
    }

    hide() {
        this.classList.remove("announcement-banner--visible");
        this.isVisible = false;
        this.inert = true;
    }

    saveInteraction() {
        localStorage.setItem("closedAnnouncementId", this.announcementId);
    }

    onClose() {
        this.hide();
        this.saveInteraction();

        setTimeout(() => {
            this.remove();
        }, 300);
    }
}

customElements.define("announcement-banner", AnnouncementBanner);
